<div class="sidenav">
  @if (project(); as project) {
    @if (!projectPermissionService.hasWritePermission(project)) {
      <div class="sidenav-header-explore">
        <mat-icon>explore</mat-icon>
        <div>
          <h3>Explore</h3>
          <span>Read-only view</span>
        </div>
      </div>
    }
    <mat-list role="navigation" class="sidenav--list">
      <a mat-list-item
         routerLink="setting"
         routerLinkActive="active"
         class="sidenav--list-link multi-line"
         (click)="onNavigate()">
        <span matListItemIcon><div class="step">1</div></span>
        <div matListItemTitle>Search strategy and <br/>inclusion criteria</div>
      </a>
      <a mat-list-item
         routerLink="search-setting"
         routerLinkActive="active"
         class="sidenav--list-link"
         (click)="onNavigate()">
        <span matListItemIcon><div class="step">2</div></span>
        <div matListItemTitle>Search queries</div>
      </a>
      <a mat-list-item
         routerLink="screening"
         routerLinkActive="active"
         class="sidenav--list-link"
         (click)="onNavigate()">
        <span matListItemIcon><div class="step">3</div></span>
        <div matListItemTitle>Identified papers</div>
      </a>
      <!--<a mat-list-item
         routerLink="chat"
         routerLinkActive="active"
         class="sidenav--list-link"
         (click)="onNavigate()">
        <mat-icon matListItemIcon>forum</mat-icon>
        <div matListItemTitle>Chat</div>
        <button
          mat-icon-button
          matListItemMeta
          (click)="onSettingClick()"
          class="settings-btn">
          <mat-icon>settings</mat-icon>
        </button>
      </a> -->
      <a mat-list-item
         routerLink="analysis"
         routerLinkActive="active"
         class="sidenav--list-link"
         (click)="onNavigate()">
        <span matListItemIcon><div class="step">4</div></span>
        <div matListItemTitle>Analysis (Beta)</div>
      </a>
      <!--   <a mat-list-item class="disabled">
           <mat-icon matListItemIcon>rate_review</mat-icon>
           <div matListItemTitle>Review-writer</div>
         </a>
         <a mat-list-item class="disabled">
           <mat-icon matListItemIcon>pageview</mat-icon>
           <div matListItemTitle>Review-check</div>
         </a>-->
    </mat-list>
  }

</div>
